<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99732 6.83544H14.9439C15.6308 6.83544 16.1951 6.27117 16.1951 5.58422V4.25122C16.1951 3.56428 15.6308 3 14.9439 3H5.99732C5.31037 3 4.75427 3.56428 4.75427 4.25122V5.58422C4.75427 6.27117 5.31037 6.83544 5.99732 6.83544ZM16.6041 20.6958C19.2274 20.6958 21.3541 18.5692 21.3541 15.9458C21.3541 13.3224 19.2274 11.1958 16.6041 11.1958C13.9807 11.1958 11.8541 13.3224 11.8541 15.9458C11.8541 18.5692 13.9807 20.6958 16.6041 20.6958ZM5.57197 8.90457C5.57197 8.55292 5.71918 8.20945 5.98087 7.97229H5.99723H16.5958C16.8575 8.20945 17.0129 8.54475 17.0129 8.90457V9.9677C16.8902 9.95135 16.7512 9.95135 16.604 9.95135H16.604C15.1974 9.95135 13.8398 10.442 12.7849 11.3252C12.7476 11.3625 12.7103 11.3964 12.6843 11.42C12.6704 11.4325 12.6597 11.4422 12.654 11.4479C12.6377 11.4561 12.6213 11.4724 12.605 11.4888L12.605 11.4888H6.81502C6.12807 11.4888 5.57197 10.9245 5.57197 10.2376V8.90457ZM10.6097 15.9455C10.6097 14.7434 10.9613 13.5985 11.6074 12.6335H2.76705C2.49718 12.8706 2.34998 13.2059 2.34998 13.5576V14.8906C2.34998 15.5775 2.91425 16.1418 3.6012 16.1418H10.6097V15.9455ZM4.37 17.2869H10.7651C11.0841 18.7098 11.9182 19.9529 13.0795 20.7952H5.21233C4.52538 20.7952 3.9611 20.2309 3.9611 19.544V18.2028C3.9611 17.8512 4.10831 17.524 4.37 17.2869Z"
            fill="url(#paint0_linear_5156_472)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5156_472"
                x1="11.8518"
                y1="20.7953"
                x2="11.8518"
                y2="3"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#3F414B" />
                <stop offset="1" stop-color="#6F727E" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
